import { createSteeringURL } from '@/api'
import { steeringAuthInit } from '@/stores/auth'
import { createBaseAPIStore } from '@/stores/util'
import { Category, FundingCategory, Language, LinkType, MusicFocus, Topic, Type } from '@/types'

export { useAuthStore, useUserStore } from '@/stores/auth'
export { useEpisodeStore } from '@/stores/episodes'
export { useFilesStore } from '@/stores/files'
export { useImageStore } from '@/stores/images'
export { useLicenseStore } from '@/stores/licenses'
export { useMediaStore } from '@/stores/media'
export { useMediaSourceStore } from '@/stores/media-sources'
export { usePlayoutStore } from '@/stores/playout'
export { useProfileStore } from '@/stores/profiles'
export { useProgramStore } from '@/stores/program'
export { useRadioSettingsStore } from '@/stores/radio-settings'
export { useRRuleStore } from '@/stores/rrules'
export { useScheduleStore } from '@/stores/schedules'
export { useShowStore } from '@/stores/shows'
export { useTimeSlotStore } from '@/stores/timeslots'

export const useFundingCategoryStore = createBaseAPIStore<FundingCategory>(
  'fundingCategories',
  createSteeringURL.prefix('funding-categories'),
  steeringAuthInit,
  { syncOnAuth: true, syncOnLocaleChange: true },
)
export const useCategoryStore = createBaseAPIStore<Category>(
  'categories',
  createSteeringURL.prefix('categories'),
  steeringAuthInit,
  { syncOnAuth: true, syncOnLocaleChange: true },
)
export const useLanguageStore = createBaseAPIStore<Language>(
  'languages',
  createSteeringURL.prefix('languages'),
  steeringAuthInit,
  { syncOnAuth: true, syncOnLocaleChange: true },
)
export const useTopicStore = createBaseAPIStore<Topic>(
  'topics',
  createSteeringURL.prefix('topics'),
  steeringAuthInit,
  { syncOnAuth: true, syncOnLocaleChange: true },
)
export const useTypeStore = createBaseAPIStore<Type>(
  'types',
  createSteeringURL.prefix('types'),
  steeringAuthInit,
  { syncOnAuth: true, syncOnLocaleChange: true },
)
export const useMusicFocusStore = createBaseAPIStore<MusicFocus>(
  'musicFocuses',
  createSteeringURL.prefix('music-focus'),
  steeringAuthInit,
  { syncOnAuth: true, syncOnLocaleChange: true },
)

export const useLinkTypeStore = createBaseAPIStore<LinkType>(
  'linkTypes',
  createSteeringURL.prefix('link-types'),
  steeringAuthInit,
  { syncOnAuth: true },
)
